import React from 'react';

import ConfirmingTabsView from './Confirming/ConfirmingTabsView';
import CreditLineTabsView from './CreditLine/CreditLineTabsView';
import FactoringTabsView from './Factoring/FactoringTabsView';

export interface IFinanceTabConfig {
  value: string;
  label: string;
  Component: React.ComponentType;
}

export const FINANCE_TABS: IFinanceTabConfig[] = [
  {
    value: 'factoring',
    label: 'Factoring',
    Component: FactoringTabsView,
  },
  {
    value: 'confirming',
    label: 'Confirming',
    Component: ConfirmingTabsView,
  },
  {
    value: 'credit-line',
    label: 'Línea de crédito',
    Component: CreditLineTabsView,
  },
];

export const FINANCE_TAB_ITEMS = FINANCE_TABS.map(({ value, label }) => ({
  value,
  label,
}));

export const FINANCE_DEFAULT_TAB = FINANCE_TABS[0].value;

export const getTabComponent = (
  value: string,
): React.ComponentType | undefined =>
  FINANCE_TABS.find((tab) => tab.value === value)?.Component;
